<template>
  <div
    class="mask_root"
    v-show="visible"
  >
    <div class="mask">
    </div>
    <div
      class="mask_wrap"
      @click="visible=false"
    >
      <div class="mask_modal">
        <img
          @click="visible=false"
          src="@/assets/images/close.png"
          class="close_mask"
        />
        <div id="qrcode"></div>
        <div class="mask_content">扫码咨询</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AdviserQrcodeModal',
  data() {
    return {
      visible: false,
      qrcodeObj: {}
    }
  },
  mounted() {
    this.qrcodeObj = new window.QRCode('qrcode', {
      text: '永远相信美好的事情即将发生',
      width: 200,
      height: 200,
      colorDark: '#000',
      colorLight: '#fff',
      correctLevel: window.QRCode.CorrectLevel.H
    })
  },
  methods: {
    show(url) {
      this.visible = true;
      this.qrcodeObj.makeCode(url);
    }
  }
}
</script>
<style lang="scss" scoped>
.mask_root {
  .mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.45);
  }
  .mask_wrap {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    overflow: auto;
    outline: 0;
    .mask_modal {
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      padding: 50px;
      position: relative;
      top: 150px;
      width: 300px;
      min-height: 300px;
      margin: 0 auto;
      background: #fff;
      border-radius: 10px;
      .close_mask {
        position: absolute;
        right: 10px;
        top: 10px;
        width: 15px;
        height: 15px;
        cursor:pointer;
      }
      .mask_content {
        font-size: 22px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #3b3b58;
        text-align: center;
        margin-top: 20px;
      }
    }
  }
}
</style>
